/**
 * Admin Route Component
 *
 * Restricts routes to authenticated admin users.
 */

import { type ReactElement, type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { ROUTES } from '@utils/constants';
import { useAuth } from '../hooks/useAuth';

interface AdminRouteProps {
  children: ReactNode;
}

export function AdminRoute({ children }: AdminRouteProps): ReactElement {
  const { isAuthenticated, isLoading, isAdmin, oauthEnabled } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="auth-loading">
        <p>Checking authentication...</p>
      </div>
    );
  }

  if (!oauthEnabled) {
    return <>{children}</>;
  }

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  if (!isAdmin) {
    return (
      <div className="admin-denied" role="alert">
        <h2>Access Denied</h2>
        <p>You do not have administrator privileges to access this page.</p>
      </div>
    );
  }

  return <>{children}</>;
}
